import {ObjectPoints} from './ObjectPoints';
import {Injectable} from '@angular/core';
import {ObjectGapHelperService} from '../../object-gap-helper.service';

interface Config {
  newPosition?: any;
}

@Injectable()
export class Intersector {

  constructor(
    private objectGapHelper: ObjectGapHelperService
  ) {

  }

  private static doPolygonsIntersect(firstPolygonPoints: Array<any>, secondPolygonPoints: Array<any>): boolean {
    const polygons = [firstPolygonPoints, secondPolygonPoints];
    let minA, maxA, projected, i = 0, i1, j, minB, maxB;

    for (; i < polygons.length; i++) {

      // for each polygon, look at each edge of the polygon, and determine if it separates
      // the two shapes
      const polygon = polygons[i];
      for (i1 = 0; i1 < polygon.length; i1++) {

        // grab 2 vertices to create an edge
        const i2 = (i1 + 1) % polygon.length;
        const p1 = polygon[i1];
        const p2 = polygon[i2];

        // find the line perpendicular to this edge
        const normal = {x: p2.y - p1.y, y: p1.x - p2.x};

        minA = maxA = undefined;
        // for each vertex in the first shape, project it onto the line perpendicular to the edge
        // and keep track of the min and max of these values
        for (j = 0; j < firstPolygonPoints.length; j++) {
          projected = normal.x * firstPolygonPoints[j].x + normal.y * firstPolygonPoints[j].y;
          if (minA === undefined || projected < minA) {
            minA = projected;
          }
          if (maxA === undefined || projected > maxA) {
            maxA = projected;
          }
        }

        // for each vertex in the second shape, project it onto the line perpendicular to the edge
        // and keep track of the min and max of these values
        minB = maxB = undefined;
        for (j = 0; j < secondPolygonPoints.length; j++) {
          projected = normal.x * secondPolygonPoints[j].x + normal.y * secondPolygonPoints[j].y;
          if (minB === undefined || projected < minB) {
            minB = projected;
          }
          if (maxB === undefined || projected > maxB) {
            maxB = projected;
          }
        }

        // if there is no overlap between the projects, the edge we are looking at separates the two
        // polygons, and we know there is no overlap
        if (maxA < minB || maxB < minA) {
          return false;
        }
      }
    }
    return true;
  }

  private static objectsIntersects(firstObjectPoints: ObjectPoints, secondObjectPoints: ObjectPoints): boolean {
    return Intersector.doPolygonsIntersect(firstObjectPoints.pointsXY(), secondObjectPoints.pointsXY())
      && Intersector.doPolygonsIntersect(firstObjectPoints.pointsXZ(), secondObjectPoints.pointsXZ());
  }

  objectIntersectsOtherObjects(firstObject, staticObjects: Array<any>, config: Config = {}): boolean {
    let intersects = false,
      staticObjectPoints,
      gap,
      staticObjectEntity,
      i = 0;

    const firstObjectPoints = new ObjectPoints(firstObject);
    const firstObjectEntity = firstObject.userData.entity;

    for (; i < staticObjects.length; i++) {
      staticObjectPoints = new ObjectPoints(staticObjects[i]);
      staticObjectEntity = staticObjects[i].userData.entity;
      gap = this.objectGapHelper.getGapBetweenTwoObjects(firstObjectEntity, staticObjectEntity);
      firstObjectPoints.setBorder(gap);
      if (config.newPosition) {
        firstObjectPoints.setPosition(config.newPosition);
      }
      intersects = Intersector.objectsIntersects(firstObjectPoints, staticObjectPoints);
      if (intersects) {
        break;
      }
    }

    return intersects;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/collision/polygon/Intersector.ts